import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {Session} from '../../services/session/session.service';
import {DataService} from '../../services/utils/data/data.service';
import {AuthenticationService} from '../../services/auth/auth.service';

export const roles = {
  "JEFE_ADQUISICIONES": 1,
  "JEFE_ADMINISTRACION": 2,
  "DESARROLLADOR": 3,
  "GERENTE_GENERAL": 5,
  "ENCARGADO_DE_BODEGA": 6,
  "ENCARGADO_DE_SALA": 9,
  "ENCARGADO_DE_AREA": 10,
  "JEFE_DE_PRODUCCION": 11,
  "ENCARGADO_DE_SALA_TITULAR": 13,
  "ENCARGADO_DE_LOGISTICA": 14,
  "CONTROL_INTERNO": 8,
};

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    nivelPrivilegios: number;
    roles?: number[];
    class: string;
}
export const ROUTES_CLEAN: RouteInfo[] = [];


export const AVAILABLE_ROUTES: RouteInfo[] = [
  //{ path: '/dashboard/home', title: 'Panel General',  icon: 'dashboard', class: '' , roles: [roles["DESARROLLADOR"], roles["JEFE_ADQUISICIONES"], roles["JEFE_ADMINISTRACION"]]},
  { path: '/administrar/usuarios', title: 'Administrar Usuarios',  icon: 'badge', class: '', nivelPrivilegios: 70, roles: [roles["DESARROLLADOR"],roles["JEFE_ADMINISTRACION"]]},
  { path: '/administrar/codigos', title: 'Administrar QRs',  icon: 'qr_code_2', class: '', nivelPrivilegios: 70, roles: [roles["DESARROLLADOR"],roles["JEFE_ADMINISTRACION"]]},
  { path: '/administrar/trabajadores', title: 'Administrar Trabajadores',  icon: 'engineering', nivelPrivilegios: 70, class: '', roles: [roles["DESARROLLADOR"],roles["JEFE_ADMINISTRACION"]]},
  { path: '/administrar/empresas', title: 'Administrar Empresas',  icon: 'building', class: '', nivelPrivilegios: 100, roles: [roles["DESARROLLADOR"],roles["JEFE_ADMINISTRACION"]]},
  //{ path: '/configurar', title: 'Configurar',  icon: 'settings', class: '', roles: [roles["DESARROLLADOR"], roles["JEFE_ADQUISICIONES"], roles["JEFE_ADMINISTRACION"]]},
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor(
    private session: Session,
    private dataService: DataService,
    private router: Router,
    public authService: AuthenticationService
  ) { }

  ngOnInit() {
    let userRolesRaw = this.session.currentUser.roles;
    let userRoles = [];

    for(let i = 0; i < userRolesRaw.length; i++){
      userRoles.push(+userRolesRaw[i].idRoles);
    }

    let userRoutes : RouteInfo[] = [];

    for(let i = 0; i < AVAILABLE_ROUTES.length; i++){
      if(userRoles.some(it => AVAILABLE_ROUTES[i].roles.includes(it)) && this.session.currentUser.nivelPrivilegios >= AVAILABLE_ROUTES[i].nivelPrivilegios){
        userRoutes.push(AVAILABLE_ROUTES[i]);
      }
    }

    this.menuItems = userRoutes;
  }

  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };

  salir(){
    this.authService.logout(() => {
      this.router.navigateByUrl("pages/login");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts